import { QUERY_KEY } from '@/constants/queryKey'
import { fetchMultiDropdownValue, MultiDropdownResponse } from '@/api/fetchMultiDropdownValue'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

// Types
import { MULTI_DROPDOWN_KEYS } from '@/types/system-dropdown/multi'

interface UseMultiDropdownValuesProps {
  keys: MULTI_DROPDOWN_KEYS
}

const useMultiDropdownValues = ({ keys }: UseMultiDropdownValuesProps) => {
  const router = useRouter()

  const locale = router.locale

  const { data: featuredCategories = {} as MultiDropdownResponse } = useQuery({
    queryKey: [QUERY_KEY.FETCH_MULTI_DROPDOWN_VALUE, keys, locale],
    queryFn: () => fetchMultiDropdownValue({ keys }),
  })

  return { shopHomeFeaturedList: featuredCategories?.shopHomeFeatured || [] }
}

export default useMultiDropdownValues
